export default "__VITE_ASSET__D4$1tjWz__"